export default "__VITE_ASSET__9a1988d6__"